import Navbar from '../components/Navbar'

import Form from '../components/Form/Form'

import { formData, sendInfo } from '../data/anotherReserveFormData'
import { formAnalysis } from '../helpers/analysis'

const AnotherReserveForm = () => {
    return (
        <div className="background">
            <Navbar />
            <Form formData={formData} sendInfo={sendInfo} analysis={formAnalysis} />
        </div>
    )
}

export default AnotherReserveForm